import config from "src/config";
import {
  PDA1123_R01RecoverRequest,
  PDA1123_R01ScanResult,
} from "src/containers/PDA/PDA1123_R01/PDA1123_R01Dto";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData, postData } from "src/utils/axios/serverHelper";

const baseUrl = `${config.apiUrl}/PDA1123_R01`;

export const scanLot = (lotNo: string) =>
  getData<ResponseDto<PDA1123_R01ScanResult>>(`${baseUrl}/scan/${encodeURIComponent(lotNo)}`);

export const recover = (request: PDA1123_R01RecoverRequest) =>
  postData<PDA1123_R01RecoverRequest, ResponseDto<string>>(`${baseUrl}/recover`, request);
